import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import routeTitles from '../../constants/routeTitles';
import { setDocumentTitle } from '../../helpers/pageTitle';

/**
 * Route-driven document.title. Renders nothing; on every pathname change it
 * looks up the first matching entry in the central route map and sets the tab
 * title to "<Page> | Pacer". This guarantees a correct title even when a page is
 * reached by an in-place navigation that does not remount the page component
 * (drill-down from a graph, applying a saved view, etc.).
 *
 * Pages with data-driven titles may still refine the title after load via
 * setDocumentTitle(); their componentDidMount/effect runs after this effect.
 * The catch-all (404) sets its own title since it has no fixed path to match.
 */
const RouteTitle = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		const match = routeTitles.find((route) =>
			matchPath(pathname, { path: route.path, exact: route.exact ?? false })
		);
		setDocumentTitle(match ? match.title : null);
	}, [pathname]);

	return null;
};

export default RouteTitle;
